import styled from "styled-components";
import MaskedInput from "react-input-mask";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  position: relative;

  & > button {
    position: absolute;
    right: 13px;;
    background: transparent;
  }
`;

export const Input = styled(MaskedInput)`
  width: 100%;
  height: 60px;
  padding: 13px;

  border-radius: ${theme.border.mediumRadius};
  border: 1px solid #B9C1CB;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.gray900};
  font-weight: 400;
  padding-top: 25px;

  &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #C4C4C4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #C4C4C4;
  }

  &::-ms-input-placeholder { /* Microsoft Edge */
    color: #C4C4C4;
  }
`;
